import { createReducer } from "@reduxjs/toolkit";
import { uiSetAuthorizationToken } from "Store/Actions";

export const Authorization = createReducer(null, {
  [uiSetAuthorizationToken.type]: (_, { payload: token }) => token
});
